import {
    Box,
    Button,
    Flex,
    Text,
} from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import useApp from '../context/AppContext'
import Player from './Player'

function Team() {

    const [params] = useSearchParams()
    const {teams, soldPlayers, players, reservedPlayers} = useApp()
    const tid = params.get('team')
    const [team, setTeam] = useState(null)
    const navigate = useNavigate()

    const [teamPlayers, setTeamPlayers] = useState([])

    useEffect(() => {
        setTeam(teams.teams[tid])
    }, [params])

    useEffect(() => {
        
        if(team && soldPlayers && players && reservedPlayers)
        {
            let plays = []

            soldPlayers.filter(s => s.tid === tid).map(s => {
                let obj = {
                    name: players?.players[s.pid]?.name,
                    cost: s.cost,
                    category: players?.players[s.pid]?.category
                }

                plays.push(obj)
            })

            reservedPlayers.filter(s => s.tid === tid).map(s => {
                let obj = {
                    name: players?.players[s.pid]?.name,
                    cost: s.cost,
                    category: players?.players[s.pid]?.category
                }

                plays.push(obj)
            })


            plays.sort((a,b) => a.name > b.name?1:-1)

            setTeamPlayers([...plays])

        }

    }, [team, soldPlayers, players, reservedPlayers])

    return (
        <Flex
            direction={'column'}
            px={5}
            py={2}
            alignItems={'center'}
        >
            <Box fontWeight={500} fontSize={"24px"}>{team?.name}</Box>
            <Box fontWeight={500}>Reserved Points Left: {team?.reservedPoints}</Box>
            <Box fontWeight={500}>Extra Points Left: {team?.extraPoints}</Box>
            <Box fontWeight={500}>Total Points Left: {team?.points}</Box>

            <Button onClick={() => navigate('/printteam', {
                state:{team: team}
            })}>Print</Button>

            <Flex
                direction={'row'}
                w={'full'}
                wrap={'wrap'}
                gap={3}
                mt={5}
                justifyContent="space-between"
            >
                {
                    teamPlayers?.map(p => 
                        <Flex
                        w={'48%'}
                        maxW="300px"
                        justifyContent={'space-between'}
                        py={3}
                        px={4}
                        bg={'rgba(0,0,0,0.2)'}
                        borderRadius={10}
                        cursor={'pointer'}
                        transition="all 0.25s"
                        _hover={{
                            border: "1px",
                        }}
                        >
                            <Text>
                            {p.name}
                            </Text>
                            
                            <Text>{p.cost}</Text>
                        </Flex>
                    )
                }
            </Flex>

        </Flex>
    )
}

export default Team